import type { StepKey } from "../types/stepKey";
import type { WorkflowStep } from "../types/workflowStep";

export class FlowEngine {
  constructor(private readonly workflow: WorkflowStep[]) {}

  getNextStep(currentStep: StepKey): WorkflowStep | null {
    const currentIndex = this.workflow.findIndex(
      step => step.key === currentStep
    );

    if (currentIndex === -1) {
      return null;
    }

    return this.workflow[currentIndex + 1] ?? null;
  }

  getPreviousStep(currentStep: StepKey): WorkflowStep | null {
    const currentIndex = this.workflow.findIndex(
      step => step.key === currentStep
    );

    if (currentIndex === -1) {
      return null;
    }

    return this.workflow[currentIndex - 1] ?? null;
  }
}


// private readonly workflow => meaning Can read. Cannot modify.

